import { switchConstants } from "../constants/switch.constants";

export function menuswitch(state = 0, action) {
    switch (action.type) {
        case switchConstants.SOCIAL_MEDIA:
            // console.log("request")
            return 0;
        case switchConstants.ACCOUNT:
            return 1;
        case switchConstants.HACKED:
            return 2;
        default:
            return state;
    }
}